module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('Page', [_c('PageBody', [_c('vwButton', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('vwButton', {
    attrs: {
      "primary": "",
      "disabled": ""
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('vwButton', {
    attrs: {
      "warn": ""
    }
  }, [_vm._v("Warn")]), _vm._v(" "), _c('vwButton', {
    attrs: {
      "origin": ""
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('vwButton', {
    attrs: {
      "plain": ""
    }
  }, [_vm._v("Plain-Default")]), _vm._v(" "), _c('vwButton', {
    attrs: {
      "mini": "",
      "primary": ""
    }
  }, [_vm._v("Mini")]), _vm._v(" "), _c('vwButton', {
    attrs: {
      "mini": "",
      "origin": ""
    }
  }, [_vm._v("Mini")]), _vm._v(" "), _c('vwButton', {
    attrs: {
      "mini": "",
      "plain-primary": ""
    }
  }, [_vm._v("Mini")]), _vm._v(" "), _c('vwButton', {
    attrs: {
      "mini": "",
      "plain": ""
    }
  }, [_vm._v("Mini")]), _vm._v(" "), _c('vwButton', {
    attrs: {
      "mini": "",
      "warn": ""
    }
  }, [_vm._v("Mini")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-4f0bb453!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/buttonView.vue
// module id = 239
// module chunks = 0